export default class AxisConfigScaleLevel {
  public id: string;

  public position: number;

  public minValue: number;

  public maxValue: number;

  public label: string;

  constructor(obj: any = {}) {
    this.id = obj.id;
    this.position = obj.position || 0;
    this.minValue = obj.minValue || 0;
    this.maxValue = obj.maxValue || 0;
    this.label = obj.label || '';
  }
}
